import React, { useCallback, useMemo, useState } from "react";
import { Button, makeStyles } from "@material-ui/core";
import { Trans, useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Publish } from "@material-ui/icons";
import { DropzoneAreaBase } from "material-ui-dropzone";
import { emptyString } from "constants/defaultValues";
import { addToast } from "components/notifications";
import { useQueryWithErrorHandling } from "hooks/errorHandling";
import { ALLOWED_FILE_EXTENSION_UPLOADS } from "features/dataCompletion/queries";

const useStyles = makeStyles(() => ({
  endIcon: {
    marginLeft: "2px",
    verticalAlign: "middle",
    fontSize: 10,
  },
  uploadBtn: (props) => {
    return {
      backgroundColor: props.disabledDropzone ? "rgba(0, 0, 0, 0.26)" : "rgb(238, 0, 0)",
      textTransform: "lowercase",
      color: "white",
      height: 25,
      fontSize: "12px",
      cursor: "pointer",
    };
  },
  dropzoneRoot: (props) => {
    return {
      minHeight: "0px !important",
      width: "fit-content",
      float: "right",
      padding: "5px 5px 8px",
      fontSize: "12px",
      pointerEvents: props.disabledDropzone && "none",
      cursor: "default",
      clickable: false,
      borderWidth: 2,
      borderColor: "rgba(0, 0, 0, 0.25)",
    };
  },
  dropzoneText: {
    margin: 0,
  },
}));

function UploadDocuments(props) {
  const { onUpload, disabled, filesLimit } = props;
  const styleProps = useMemo(() => ({ disabledDropzone: disabled }), [disabled]);
  const classes = useStyles(styleProps);
  const { t } = useTranslation();

  const [fileTypes, setFileTypes] = useState();

  useQueryWithErrorHandling(ALLOWED_FILE_EXTENSION_UPLOADS, {
    onCompleted: (data) => {
      setFileTypes(data.allowedFileExtensionUploads);
    },
  });

  const getUploadBtn = useCallback(() => {
    return (
      <Trans
        i18nKey="DataCompletion.AddFile"
        components={
          <Button
            variant="contained"
            disabled={disabled}
            endIcon={<Publish />}
            className={classes.uploadBtn}
            classes={{ endIcon: classes.endIcon }}
          />
        }
      />
    );
  }, [disabled, classes]);

  const getFileLimitExceedMessage = useCallback(
    (filesLimit) => {
      addToast(t("General.MaximumFilesToDrop", { filesLimit: filesLimit }), "error");
    },
    [t]
  );

  const handleDropRejected = useCallback(() => {
    addToast(t("General.FileTypeOrFileSizeNotAccepted"), "error");
  }, [t]);

  return (
    <DropzoneAreaBase
      acceptedFiles={[fileTypes]}
      Icon={getUploadBtn}
      dropzoneText={emptyString}
      showPreviewsInDropzone={false}
      showAlerts={false}
      filesLimit={filesLimit}
      maxFileSize={104857600}
      onAdd={onUpload}
      onDrag={onUpload}
      onDropRejected={handleDropRejected}
      getFileLimitExceedMessage={getFileLimitExceedMessage}
      classes={{ root: classes.dropzoneRoot, text: classes.dropzoneText }}
    />
  );
}

UploadDocuments.defaultProps = {
  filesLimit: 15,
};

UploadDocuments.propTypes = {
  disabled: PropTypes.bool,
  onUpload: PropTypes.func.isRequired,
  filesLimit: PropTypes.number.isRequired,
};

export default UploadDocuments;
